<template>
    <div class="add-team-member container">
        <div class="row pt-4">
            <div class="col-12">
                <div style="margin-bottom: 24px;">
                    <a class="back-button" :href="previousPageUrl">
                        <img v-bind:src="'/images/arrow_back_blue.svg'" alt style="margin: 0 4px 4px 0;"/> Back to
                        {{previousPageName}}
                    </a>
                </div>
            </div>
        </div>
        <div style="max-width: 768px;margin: 0 auto; height: 550px;">
            <div class="row">
                <div class="col-12">
                    <div class="add-team-member__title">Add a user</div>
                    <div class="add-team-member__desc">Connect with with your teammate at anywhere you are</div>
                </div>
            </div>

            <div class="row pt-5">
                <div class="col-12">
                    <div class="form-group" style="margin-bottom: 25px">
                        <label for="emails">Insert your team members' emails separated by commas. - Optional</label>
                        <br/>

                        <textarea
                            id="emails"
                            rows="3"
                            class="form-control"
                            v-model="emails"
                            placeholder="Example: test1@test.com, test2@test.com"
                        ></textarea>
                        <p id="emailsHelpBlock" class="muted">We'll send them an email invite to register.</p>
                        <div class="error-box" v-if="error">{{errorMsg}}</div>
                    </div>

                    <div class="form-group d-flex justify-content-center">
                        <button class="btn btn-invite" :disabled="this.loading" @click="sendInvitations()">
              <span class="spinner-border" role="status" v-show="this.loading">
                <span class="sr-only">Loading...</span>
              </span>
                            Send Email Invites
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['previousPageName', 'previousPageUrl', 'userRole'],

        data () {
            return {
                emails: '',
                loading: false,
                error: false,
                errorMsg: '',
            }
        },

        methods: {
            async sendInvitations () {
                this.loading = true
                this.error = false
                this.errorMsg = ''

                const emails = this.emails.replace(' ', '').split(',')

                try {
                    this.data = await axios.post('/team-members', {
                        emails: emails,
                        role: this.userRole
                    })

                    location.href = this.previousPageUrl
                } catch (e) {
                    this.loading = false
                    this.error = true
                    this.processError(e.response.data)
                }
            },

            processError (data) {
                const emails = this.emails.replace(' ', '').split(',')

                Object.keys(data).forEach(item => {
                    this.errorMsg +=
                        emails[item.match(/emails\.[\d]/g)[0].split('.')[1]] + ', '
                })

                this.errorMsg = this.errorMsg.slice(0, -2)
                this.errorMsg += ' has been registered.'
            },
        },
    }
</script>

<style scoped lang="scss">
    .add-team-member {
        &__title {
            color: #303030;
            font-family: Lato;
            font-size: 38px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 53.2px;
            text-align: center;
        }

        &__desc {
            color: #606064;
            font-family: "Open Sans", sans-serif;
            font-size: 20px;
            letter-spacing: 0;
            line-height: 28px;
            text-align: center;
        }

        label {
            color: #98a6ba;
            font-family: "Open Sans", sans-serif;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0.5px;
            line-height: 22px;
        }

        textarea {
            border: 1px solid #dce2ed !important;
            background-color: white;
        }

        p.muted {
            color: #303030;
            font-family: Lato;
            font-size: 12px;
            letter-spacing: 0;
            line-height: 20px;
        }

        .btn-invite {
            height: 56px;
            width: 320px;
            color: #fff;
            font-family: "Open Sans";
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 22px;
            text-align: center;
            background: #000;
        }

        .back-button {
            color: #0db4e6;
            font-family: "Open Sans", sans-serif;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 22px;
        }
    }

    .btn-secondary {
        border-radius: 6px;
        background-color: #5145ff;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
        border: none;
        font-size: 14px;
        font-weight: 700;
        line-height: 17px;
        color: #fff;
        padding: 12px 0;

        align-items: center;
        display: flex;
        text-align: center;
        justify-content: center;
    }

    .spinner-border {
        color: #fff;
        margin-right: 16px;
        width: 20px;
        height: 20px;
    }

    :disabled {
        cursor: progress;
    }
</style>
